<template>
    <article class="modal_devices">
        <section class="modal_devices__modal">
            <div class="modal_devices__modal__info">
                <img @click="onCancelModal" src ="./../../assets/img/icons/close.svg" class="x_button">
                <h5>Comentarios de revisión</h5>
            </div>
            <div class="modal_comments">
                <h6>Quien revisa: </h6> {{data.whoreviews || 'Sin revisión'}}
                <h6>Comentarios: </h6> {{data.comments || 'Sin revisión'}}
            </div>
        </section>
    </article>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: {
          whoreviews: null,
          comments: null
      }
    },
  },
  methods: {
        onCancelModal(event){
            this.$emit('cancel', false);
        },
  },
}
</script>
<style lang="scss" scoped>
    .modal_comments{
        padding: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/ModalComments.vue